import { useDispatch } from "react-redux";
import { elementAction } from "../../store";

export default function TextArea({
  t,
  className,
  id,
  placeholder,
  name,
  isFocus,
  theme,
  onChange,
  form,
}) {
  const dispatch = useDispatch();
  function getDescriptionWordCount() {
    return form.description.length;
  }

  function css() {
    return isFocus(name)
      ? ` border-${theme}-on-focus border-thin opacity-80 placeholder-${theme}-focus`
      : ` placeholder-${theme}-input  border-thin border-${theme}-normal`;
  }

  return (
    <>
      <div
        className={
          className +
          ` rounded-md border-b-[1px] border-${theme}-radio  hover:border-${theme}-btn-hover hover:bg-${theme}-btn-hover hover:bg-opacity-30`
        }
      >
        <span
          className={`corner-b-l-input border-${theme}-radio`}
          aria-hidden="true"
        />
        <span
          className={`corner-b-r-input border-${theme}-radio`}
          aria-hidden="true"
        />
        {/* <div
          className={`absolute w-2 h-2 left-[-1px] top-[-1px]
            group-hover:border-btn-hover-light group-active:border-btn-click-light
               border-t-[1.5px] border-l-[1.5px]`}
        />
        <div
          className={`absolute w-2 h-2 left-[-1px] bottom-[-1px]
                           group-hover:border-btn-hover-light group-active:border-btn-click-light
               border-b-[1.5px] border-l-[1.5px] `}
        />
        <div
          className={`absolute w-2 h-2 right-[-1px] bottom-[-1px]
                         group-hover:border-btn-hover-light group-active:border-btn-click-light
               border-b-[1.5px] border-r-[1.5px]`}
        /> */}
        <textarea
          className={
            `bg-transparent rounded-md h-full w-full text-xl px-4 text-${theme}-normal  pt-2 input-text ` +
            css()
          }
          maxLength="1000"
          placeholder={
            placeholder
              ? placeholder
              : t(id, {
                  armoury_crate: t("armoury_crate"),
                })
          }
          id={id}
          name={name}
          value={form.description}
          onChange={onChange}
          onFocus={() => dispatch(elementAction.setEnableRootKeyboardEvent(false))}
          onBlur={() => dispatch(elementAction.setEnableRootKeyboardEvent(true))}
          aria-description={t(id, {
            armoury_crate: t("armoury_crate"),
          })}
        />
        <div
          className={`absolute right-3 bottom-2 text-${theme}-disabled text-xl`}
          aria-hidden={"true"}
        >
          {getDescriptionWordCount()}/1000
        </div>
      </div>
    </>
  );
}
